import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { fabric } from "fabric";
import watermarkUrl from '../../assets/watermark/watermark.png'
import { dataHandlers } from "../../utils/objectHandlers";
import { setZoom, saveState } from "../../Store/reducers/fabriccontrolsSlice";
import { handleDownload } from "../../utils/fabricHelper.js";
import { showPopup } from "../../Store/reducers/popUpSlice.js";
import { embedFont } from "../../utils/fontHelper.js";
import { applyWatermarkOverlay } from "../../utils/waterMark.js";
import { enableDownload,disableDownload } from "../../Store/reducers/downloadSlice.js";
import {
  setFabricCanvas,
  setImageloaded,
  setPendingDownload,
} from "../../Store/reducers/fabricCanvasSlice";
import { setFabricCanvasAsImage } from "../../Store/reducers/svgSlice.jsx";
import { useLocation } from "react-router-dom";
import { fabricclampViewport } from "../customHooks/useZoomControls.jsx";
let BASE_WIDTH = 650;
let BASE_HEIGHT = 500;

const Canvas = () => {
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const pendingDownload = useSelector((state) => state.fabricCanvas.pendingDownload);
  const imageloaded = useSelector((state) => state.fabricCanvas.imageloaded);
  const canvasBackground = useSelector((state) => state.canvas.canvasAsImage);
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const canvasesState = useSelector((state) => state.canvasesstate.canvases);
   const pixiZoom       = useSelector(s => s.canvas.zoom);
  const { svgDetails } = useSelector((state) => state.svgDetails);
  const zoom = useSelector((state) => state.canvasesstate.zoom);
   const user = useSelector((state) => state.user.data);
   const userRole = user?.data?.user_role || "guest";
   const isFreeUser = userRole !== "premium"; 
   
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("product_id");
  const selectedMockup =
    useSelector((state) => state.mockupCategories.selectedMockup) || [];
  BASE_WIDTH = activeTab === "editMockup" ? selectedMockup?.width : 650;
  BASE_HEIGHT = activeTab === "editMockup" ? selectedMockup?.height : 500;
  const [isLoading, setIsLoading] = useState(false);

  // const [isImageAdded, setIsImageAdded] = useState(
  //     localStorage.getItem(`isImageAdded_${productId}`) === "true"
  // );

  // ---------------- Canvas Initialization ----------------
  useEffect(() => {
    const bgColor = activeTab === "editMockup" ? "transparent" : "#ffffff";
    const canvas = new fabric.Canvas("svg-editor", {
      // perPixelTargetFind:true,
      selection: true,
      preserveObjectStacking: true,
      backgroundColor: bgColor,
        
                   
    });
    
   
    fabric.Object.prototype.set({
      cornerColor: "#EE1E6E",
      cornerStyle: "circle",
      
      transparentCorners: false,
      borderColor: "#EE1E6E",
      borderScaleFactor: 2,
      
    });

    fabric.IText.prototype.initialize = (function(orig) {
      return function(...args) {
        orig.apply(this, args);
        this.setControlsVisibility({
          ml: false,
          mr: false,
        
        });
      };
    })(fabric.IText.prototype.initialize);

    // Panning state.
    let isPanning = false;
    let lastPosX = 0;
    let lastPosY = 0;
    const defaultZoom = 1;
      let isSpaceDown = false;

      const onKeyDown = (e) => {
        if (e.code === "Space") {
          isSpaceDown = true;
          // prevent scrolling by space
          e.preventDefault();
        }
      };
      const onKeyUp = (e) => {
        if (e.code === "Space") {
          isSpaceDown = false;
        }
      };
      window.addEventListener("keydown", onKeyDown);
      window.addEventListener("keyup", onKeyUp);

    const handleMouseDown = (event) => {
      const currentZoom = canvas.getZoom();
      if (event.e.which === 1 && isSpaceDown) {
        if (currentZoom > defaultZoom) isPanning = true;
        canvas.setCursor("grab");
        canvas.selection = false;
      } else {
        canvas.selection = true;
      }
      
      lastPosX = event.e.clientX;
      lastPosY = event.e.clientY;
    };

    const handleMouseMove = (event) => {
      if (!isPanning) return;
      const { clientX, clientY } = event.e;
      const deltaX = clientX - lastPosX;
      const deltaY = clientY - lastPosY;
      canvas.relativePan(new fabric.Point(deltaX, deltaY));
      lastPosX = clientX;
      lastPosY = clientY;
      fabricclampViewport(canvas);
    };

    const handleMouseUp = () => {
      isPanning = false;
      canvas.selection = true;
      canvas.defaultCursor = "default";
      fabricclampViewport(canvas);
    };

    canvas.on("mouse:down", handleMouseDown);
    canvas.on("mouse:move", handleMouseMove);
    canvas.on("mouse:up", handleMouseUp);

  
    let hoveredObject = null;

    canvas.on("mouse:over", (event) => {
      const { target } = event;
      const activeObject = canvas.getActiveObject();
        if (!target || !(target instanceof fabric.Object)) return;

       if (target === activeObject) return;
      // if (canvas.getActiveObjects().length) {
      //   return;
      // }
      
      if (
    activeObject &&
    (activeObject.type === "activeSelection" || activeObject.type === "group") &&
    activeObject._objects?.includes(target)
  ) {
    return;
  }
        hoveredObject = target;
        canvas.renderAll();
      
    });

   
    canvas.on("mouse:out", (event) => {
      hoveredObject = null;
      canvas.renderAll();
    });

  
    canvas.wrapperEl.addEventListener("mouseleave", () => {
      hoveredObject = null;
      canvas.renderAll();
    });

    
 
   canvas.on("after:render", () => {
  if (
    hoveredObject &&
    canvas.getActiveObjects().indexOf(hoveredObject) === -1
  ) {
    const ctx = canvas.getContext('2d'); 
    const bound = hoveredObject.getBoundingRect();

    ctx.save();
    ctx.strokeStyle = "#EE1E6E";
    ctx.lineWidth = 2;
    // ctx.setLineDash([5, 3]);
    ctx.strokeRect(bound.left, bound.top, bound.width, bound.height);
    ctx.restore();
  }
});


  
const handleBeforeRender = () => {
  const wm = canvas
    .getObjects("image")
    .find((o) => o.data?.isWatermark);
  if (!wm) return;

  const z = canvas.getZoom();
  const vpt = canvas.viewportTransform;

  const baseScaleX = wm.watermarkBaseScaleX;
  const baseScaleY = wm.watermarkBaseScaleY;

  wm.set({
    selectable: false,
    evented: false,
    hasControls: false,
    hasBorders: false,
    hoverCursor: "default",

    scaleX: baseScaleX / z,
    scaleY: baseScaleY / z,
    left: -vpt[4] / z,
    top: -vpt[5] / z,
  });

  wm.setCoords();
};

canvas.on("before:render", handleBeforeRender);

canvas.renderAll(); 


canvas.beginBatch = function () {
  this.__batchDepth = (this.__batchDepth || 0) + 1;
};

canvas.endBatch = function () {
  this.__batchDepth = Math.max((this.__batchDepth || 1) - 1, 0);
  if (this.__batchDepth === 0 && this.__shouldSaveAfterBatch) {
    saveCanvasState();
    this.__shouldSaveAfterBatch = false;
  }
};




    // Adjust canvas size based on window dimensions.
    const adjustCanvasSize = () => {
      const availableWidth = window.innerWidth - 700;
      const availableHeight = window.innerHeight - 150;
      const baseWidth = BASE_WIDTH;
      const baseHeight = BASE_HEIGHT;
      const scaleX = availableWidth / baseWidth;
      const scaleY = availableHeight / baseHeight;
      const scale = Math.min(scaleX, scaleY);
      canvas.setZoom(1);
      canvas.setDimensions({
        width: baseWidth * scale,
        height: baseHeight * scale,
      });
      dispatch(setZoom(1));
      canvas.renderAll();
    };

    adjustCanvasSize();
    window.addEventListener("resize", adjustCanvasSize);

    canvasRef.current = canvas;
    window.fabCanvas = canvas;

    // Load saved canvas state, if any.
    // const savedState =  localStorage.getItem(`${activeTab}CanvasState_${productId}`);
    const savedState = canvasesState[`${activeTab}CanvasState`]?.currentState;

    if (savedState) {
      const savedStatParsed = JSON.parse(savedState)
      console.log("before parsed json",savedStatParsed )
      if(savedStatParsed?.backgroundImage){
       delete savedStatParsed.backgroundImage
       console.log("updated json",savedStatParsed)
      }
      console.log("json",savedState)
      let updatedSavedState = JSON.stringify(savedStatParsed);
      canvas.__isLoadingState = true
      canvas.loadFromJSON(updatedSavedState, () => {
        canvas.__isLoadingState = false
        canvas.renderAll();
      });
    }
   
    dispatch(setFabricCanvas(canvas));

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup",   onKeyUp);
      window.removeEventListener("resize", adjustCanvasSize);
      canvas.off("mouse:down", handleMouseDown);
      canvas.off("mouse:move", handleMouseMove);
      canvas.off("mouse:up", handleMouseUp);
      canvas.off("before:render", handleBeforeRender);
      canvas.dispose();
    };
  }, [activeTab, dispatch, productId]);

  
  
  

  // ---------------- Save Canvas State ---------------
  const saveCanvasState = useCallback(() => {
    if (!fabricCanvas) return;
   
    if (fabricCanvas.__isLoadingState) return;



    const canvasState = JSON.stringify(fabricCanvas.toJSON(["perPixelTargetFind","isMainSvg", "isPremium","selectable","hasBorders","watermarkBaseScaleX",  "watermarkBaseScaleY","evented", "data"]));
    dispatch(saveState({ tab: `${activeTab}CanvasState`, canvasState }));

    if (activeTab === "editSVG") {
      const canvasJSON = JSON.stringify(fabricCanvas.toJSON(["perPixelTargetFind","isMainSvg", "isPremium","selectable","hasBorders","watermarkBaseScaleX",  "watermarkBaseScaleY","evented", "data"]));
      console.log("scg canvas json",canvasJSON)
      dispatch(setFabricCanvasAsImage(canvasJSON));
    }
  

    if (fabricCanvas._objects && fabricCanvas.contextTop) {
      fabricCanvas.renderAll();
    }
  }, [fabricCanvas, activeTab, dispatch]);

  const debouncedSave = debounce(() => {
    saveCanvasState();
  }, 50);

  useEffect(() => {
    if (!fabricCanvas) return;

    fabricCanvas.isBatching = function () {
      return (this.__batchDepth || 0) > 0;
    };
    
    fabricCanvas.beginBatch = function () {
      this.__batchDepth = (this.__batchDepth || 0) + 1;
      console.log(" Begin Batch", this.__batchDepth);
    };
    
    fabricCanvas.endBatch = function () {
      this.__batchDepth = Math.max((this.__batchDepth || 1) - 1, 0);
      console.log(" End Batch", this.__batchDepth, "Should Save?", this.__shouldSaveAfterBatch);
      if (this.__batchDepth === 0 && this.__shouldSaveAfterBatch) {
        console.log(" Saving canvas state now");
        saveCanvasState();
        this.__shouldSaveAfterBatch = false;
      }
    };
    

    const onObjectAdded   = async (e) => {
      if ( fabricCanvas._isGrouping  ) return;
      let addedObj = e?.target
      console.log("addedobj  is " ,addedObj,  addedObj?.data,)
      
      
      const isPremiumMain = addedObj?.isMainSvg && addedObj?.isPremium && isFreeUser;
      if (isPremiumMain) {
        console.log("added premium",isPremiumMain)
        if (activeTab !== "editMockup") {
       dispatch(disableDownload());
        }
      }

      
      if ( fabricCanvas.__isLoadingState || fabricCanvas.__isLoadingSvglayers ) return;
   
     
      if (addedObj.data?.isWatermark ) return;
    
        if ((addedObj.isPremium && isFreeUser)  ) {
          
          if (!addedObj._skipPopup) { 
           dispatch(
                  showPopup("Please upgrade to premium,this is a premium Item.")
                );
              }
      let existing =   await  applyWatermarkOverlay(fabricCanvas, watermarkUrl);
        console.log("fabcanvas objects",fabricCanvas
          .getObjects("image"), fabricCanvas._objects)
          // debugger
        }

       
        setTimeout(() => {
          if (addedObj._isCloned) return; 
          if (addedObj._restoreObjectsState && addedObj._objects?.length > 1) {
            const selection = new fabric.ActiveSelection(addedObj._objects, {
              canvas: fabricCanvas,
            });
            fabricCanvas.setActiveObject(selection);
          } else {
            fabricCanvas.setActiveObject(addedObj);
          }
         
          const watermark = fabricCanvas.getObjects().find(obj => obj.data?.isWatermark);
          if (watermark) {
            fabricCanvas.bringToFront(watermark);
          }
          fabricCanvas.renderAll();
           if (fabricCanvas._checkLayerMovability) {
           fabricCanvas._checkLayerMovability();
  }
          // debouncedSave();
        }, 50);
        

        debouncedSave();
       
       };
       const onObjectRemoved = (e) => {
        if ( fabricCanvas._isGrouping ) return; 
        let removedObj = e?.target;
        console.log("Removed object is", removedObj, removedObj?.data);
       
          const remainingMainPremiumSVG = fabricCanvas._objects.some(
            (obj) => obj.isPremium === true && obj.isMainSvg === true
          );
          if (!remainingMainPremiumSVG) {
            console.log("remain premium",remainingMainPremiumSVG)
              if (activeTab !== "editMockup") {
            dispatch(enableDownload())
              }
          }
      
        if (removedObj?.isPremium === true ) {
          const remainingPremiumSVG = fabricCanvas._objects.some(
            (obj) => obj.isPremium === true
          );
      
          if (!remainingPremiumSVG) {
            const watermarkObj = fabricCanvas
              .getObjects("image")
              .find((obj) => obj.data?.isWatermark);
      
            if (watermarkObj) {
              fabricCanvas.remove(watermarkObj);
              fabricCanvas.__watermarkListenerInstalled = false;
            }
          }
        }
    
        if (!fabricCanvas.isBatching()) {
          saveCanvasState();
        } else {
          fabricCanvas.__shouldSaveAfterBatch = true;
        }
      }
    const onObjectMod     = () => { if (!fabricCanvas._isGrouping) saveCanvasState(); };
    
  
    
    fabricCanvas.on("object:added",    onObjectAdded);
    fabricCanvas.on("object:removed",  onObjectRemoved);
    fabricCanvas.on("object:modified", onObjectMod);
  
    
    return () => {
      fabricCanvas.off("object:added",    onObjectAdded);
      fabricCanvas.off("object:removed",  onObjectRemoved);
      fabricCanvas.off("object:modified", onObjectMod);
    };
  }, [fabricCanvas, user, activeTab, dispatch]);
  




  // ---------------- Set Background for "editMockup" ----------------
  const setBackgroundFromBlob = useCallback(async () => {
    if (!canvasBackground || !fabricCanvas) return;
  console.log("updated canvas bg",canvasBackground)
    // Create a flag to track if the component is still mounted
    let isMounted = true;
    setIsLoading(true); 
    const img = new Image();
    img.src = canvasBackground;
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      // If the component has unmounted, do nothing.
      if (!isMounted || !fabricCanvas.lowerCanvasEl) return;

      fabric.Image.fromURL(img.src, (fabricImg) => {
        if (!isMounted || !fabricCanvas.lowerCanvasEl) return;

        const { naturalWidth, naturalHeight } = img;
        const canvasPixelW = fabricCanvas.getWidth();
    const canvasPixelH = fabricCanvas.getHeight();

    const retina = fabricCanvas.getRetinaScaling();

    const coverScale = Math.max(
      canvasPixelW / naturalWidth * retina,
      canvasPixelH / naturalHeight * retina
    );
        fabricCanvas.setBackgroundImage(
          fabricImg,
          () => {
            if (!isMounted || !fabricCanvas.lowerCanvasEl) return;
            fabricCanvas.renderAll();
            saveCanvasState();
              let updatedCanvasState = JSON.stringify(fabricCanvas.toJSON());
            pendingDownload &&   handleDownload("editMockup",fabricCanvas,updatedCanvasState, ()=>{
                dispatch (setPendingDownload(false));
            });
          },
          {
            originX: 'center',
            originY: 'center',
            left: canvasPixelW / 2,
            top: canvasPixelH / 2,
            scaleX: coverScale,
            scaleY: coverScale
          }
        );
       
      });
    };

   
    return () => {
      isMounted = false;
    };
  }, [canvasBackground, fabricCanvas, zoom, saveCanvasState,pendingDownload]);


  
  useEffect(() => {
    if (!fabricCanvas) return;
    if (activeTab === "editMockup" && canvasBackground) {
      setBackgroundFromBlob().catch((error) =>
        console.error("Error setting canvas background:", error)
      );
    }
  }, [activeTab, canvasBackground, fabricCanvas, setBackgroundFromBlob]);

  

  // ---------------- Load SVG into Canvas (for editSVG) ----------------
  useEffect(() => {
    if (!fabricCanvas || activeTab === "editMockup") return;
    
    if (imageloaded) return; 

    const files = svgDetails?.data?.downloadable_files;
    if (!files) {
      console.error("No SVG files found in svgDetails");
      return;
    }
    const key = Object.keys(files)[0];
    const svgUrl = files[key]?.file;
    if (!svgUrl) {
      console.error("No SVG URL found in svgDetails");
      return;
    }
    fabric.loadSVGFromURL(svgUrl, (objects, options) => {
      const svgGroup = fabric.util.groupSVGElements(objects, options);
      
      svgGroup.svgLoaded = true;
   
   
   const canvasWidth = fabricCanvas.getWidth();
   const canvasHeight = fabricCanvas.getHeight();
   const minSize = 300; 

   const originalWidth  = options.width;
   const originalHeight = options.height;

  
   const widthRatio  = canvasWidth  / originalWidth;
   const heightRatio = canvasHeight  / originalHeight;
   let scale = Math.min(widthRatio, heightRatio);

   let newWidth  = originalWidth  * scale;
   let newHeight = originalHeight * scale;

  
   if (newWidth < minSize && newHeight < minSize) {
     const minWidthScale  = minSize / originalWidth;
     const minHeightScale = minSize / originalHeight;
     scale = Math.max(minWidthScale, minHeightScale);

     newWidth  = originalWidth  * scale;
     newHeight = originalHeight * scale;

     
     
     if (newWidth > canvasWidth || newHeight > canvasHeight) {
       const maxWidthScale  = canvasWidth  / originalWidth;
       const maxHeightScale = canvasHeight  / originalHeight;
       scale = Math.min(maxWidthScale, maxHeightScale);

       newWidth  = originalWidth  * scale;
       newHeight = originalHeight * scale ;
     }
   }

   svgGroup.scaleX = svgGroup.scaleY = scale - 0.1 ;
      
      console.log("svggroup",svgGroup)
      svgGroup.set({
        isMainSvg: true,
        left: fabricCanvas.width / 2 ,
        top: fabricCanvas.height / 2 ,
        originX: "center",
        originY: "center",
        padding: 0,
        selectable: true,
        ...(svgDetails?.data?.is_premium === true && { isPremium: true })
        // protected:true,
      });
      fabricCanvas.add(svgGroup);
      fabricCanvas.renderAll();
      
     //code for ungroup start
     
     const items = svgGroup._objects || [];
     if (items.length > 1) {
       svgGroup._restoreObjectsState();
       fabricCanvas.remove(svgGroup);
       fabricCanvas.__isLoadingSvglayers = true
       items.forEach(obj => {
         obj.perPixelTargetFind = true;
         if (svgDetails?.data?.is_premium === true) {
          obj.isPremium = true;
          obj.isMainSvg = true;
        }
         fabricCanvas.add(obj);
       });
       fabricCanvas.__isLoadingSvglayers = false
       fabricCanvas.renderAll();
     }
     fabricCanvas.renderAll();
   if (!svgDetails?.data?.is_premium &&  isFreeUser) {
    saveCanvasState(); 
  }
      dispatch(setImageloaded(true)); 
      console.log("inside svg pending download",pendingDownload )
      
      pendingDownload &&   handleDownload("editSVG",fabricCanvas,canvasesState, ()=>{
          dispatch (setPendingDownload(false));
      });
    });
  }, [
    fabricCanvas,
    activeTab,
    svgDetails,
    dispatch,
    imageloaded,
    saveCanvasState,
    pendingDownload,
  ]);

 

  // ---------------- Drag & Drop Handlers ----------------
  const handleDrop = async (e) => {
    e.preventDefault();
    if (!fabricCanvas) return;
    const pointer = fabricCanvas.getPointer(e);

   
  
    const keys = ["font", "image", "svg", "svgFile","premiumsvg"];
    for (let key of keys) {
      const data = e.dataTransfer.getData(key);
      if (data && dataHandlers[key]) {
        const customProps = { left: pointer.x, top: pointer.y };

        if (key === "font") {
          const font = JSON.parse(data);
          const name = font.family || font.font_family || font.name;
          const url = font.src;
          if (name && url) {
            await embedFont(name, url);
          }
        }

        await dataHandlers[key](data, fabricCanvas, customProps);
        // saveCanvasState();
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div className="flex-1 flex justify-center items-center">
      <div
        className="flex justify-center items-center"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        
      >
        <canvas id="svg-editor" />
      </div>
    </div>
  );
};

export default Canvas;
